import { useState } from "react";

interface FAQItem {
  q: string;
  a: string;
}

interface FAQAccordionProps {
  items: FAQItem[];
}

export default function FAQAccordion({ items }: FAQAccordionProps) {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <div className="space-y-3">
      {items.map((f, idx) => {
        const open = openIdx === idx;
        return (
          <div
            key={idx}
            className={`rounded-xl bg-background-900/70 border transition-colors overflow-hidden ${
              open ? "border-primary-400/40" : "border-background-200/20"
            }`}
          >
            <button
              onClick={() => setOpenIdx(open ? null : idx)}
              className="w-full flex items-center justify-between gap-4 px-5 py-4 md:px-6 md:py-5 text-left cursor-pointer"
            >
              <span className={`font-medium text-sm md:text-base ${open ? "text-foreground-100" : "text-foreground-300"}`}>
                {f.q}
              </span>
              <span
                className={`w-7 h-7 shrink-0 rounded-full flex items-center justify-center text-sm transition-all ${
                  open
                    ? "bg-primary-500 text-background-950 rotate-180"
                    : "bg-background-800 text-foreground-500"
                }`}
              >
                <i className="ri-arrow-down-s-line"></i>
              </span>
            </button>
            <div
              className={`overflow-hidden transition-all duration-300 ${
                open ? "max-h-48 opacity-100" : "max-h-0 opacity-0"
              }`}
            >
              <div className="px-5 pb-4 md:px-6 md:pb-5">
                <p className="text-sm text-foreground-500 leading-relaxed">{f.a}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}